import { ValidationMessageResolver } from '@iris/common/modules/fields/validation/validation-message-resolver/validation-message-resolver';
import { TranslateService } from '@ngx-translate/core';
import { Validators } from '@angular/forms';
import { Injectable, inject } from '@angular/core';

@Injectable()
export class EmailValidationMessageResolver implements ValidationMessageResolver {
  private readonly translateService = inject(TranslateService);

  readonly errorCode = Validators.email.name;

  getMessage(): string {
    return this.translateService.instant('label.validation.email');
  }
}
